"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f106 = void 0;
exports.f106 = {
    "ja": [
        "Jpan",
        "Brai",
        "Latn"
    ],
    "jaa": [
        "Latn"
    ],
    "jab": [
        "Latn"
    ],
    "jac": [
        "Latn"
    ],
    "jad": [
        "Arab"
    ],
    "jae": [
        "Latn"
    ],
    "jaf": [
        "Latn"
    ],
    "jah": [
        "Latn"
    ],
    "jaj": [
        "Latn"
    ],
    "jak": [
        "Latn"
    ],
    "jal": [
        "Latn"
    ],
    "jam": [
        "Latn"
    ],
    "jan": [
        "Latn"
    ],
    "jao": [
        "Latn"
    ],
    "jaq": [
        "Latn"
    ],
    "jas": [
        "Latn"
    ],
    "jat": [
        "Arab"
    ],
    "jau": [
        "Latn"
    ],
    "jax": [
        "Latn"
    ],
    "jay": [
        "Latn"
    ],
    "jaz": [
        "Latn"
    ],
    "jbe": [
        "Hebr"
    ],
    "jbi": [
        "Latn"
    ],
    "jbj": [
        "Latn"
    ],
    "jbk": [
        "Latn"
    ],
    "jbm": [
        "Latn"
    ],
    "jbn": [
        "Arab"
    ],
    "jbo": [
        "Latn"
    ],
    "jbr": [
        "Latn"
    ],
    "jbt": [
        "Latn"
    ],
    "jbu": [
        "Latn"
    ],
    "jbw": [
        "Latn"
    ],
    "jcs": [
        "Zxxx"
    ],
    "jct": [
        "Cyrl",
        "Latn"
    ],
    "jda": [
        "Tibt"
    ],
    "jdg": [
        "Arab"
    ],
    "jdt": [
        "Cyrl",
        "Hebr",
        "Latn"
    ],
    "jeb": [
        "Latn"
    ],
    "jee": [
        "Deva"
    ],
    "jeh": [
        "Latn",
        "Laoo"
    ],
    "jei": [
        "Latn"
    ],
    "jek": [
        "Latn"
    ],
    "jel": [
        "Latn"
    ],
    "jen": [
        "Latn"
    ],
    "jer": [
        "Latn"
    ],
    "jet": [
        "Latn"
    ],
    "jeu": [
        "Latn"
    ],
    "jgb": [
        "Latn"
    ],
    "jge": [
        "Geor",
        "Hebr"
    ],
    "jgk": [
        "Latn"
    ],
    "jgo": [
        "Latn"
    ],
    "jhi": [
        "Latn"
    ],
    "jhs": [
        "Zxxx"
    ],
    "jia": [
        "Latn"
    ],
    "jib": [
        "Latn"
    ],
    "jic": [
        "Latn"
    ],
    "jid": [
        "Latn"
    ],
    "jie": [
        "Latn"
    ],
    "jig": [
        "Latn"
    ],
    "jih": [
        "Zyyy"
    ],
    "jii": [
        "Zyyy"
    ],
    "jil": [
        "Latn"
    ],
    "jim": [
        "Latn"
    ],
    "jio": [
        "Zyyy"
    ],
    "jiq": [
        "Zyyy"
    ],
    "jit": [
        "Latn"
    ],
    "jiu": [
        "Latn"
    ],
    "jiv": [
        "Latn"
    ],
    "jiy": [
        "Latn"
    ],
    "jje": [
        "Hang"
    ],
    "jjr": [
        "Latn"
    ],
    "jka": [
        "Latn"
    ],
    "jkm": [
        "Zyyy"
    ],
    "jko": [
        "Latn"
    ],
    "jkp": [
        "Zyyy"
    ],
    "jkr": [
        "Zyyy"
    ],
    "jks": [
        "Zxxx"
    ],
    "jku": [
        "Latn"
    ],
    "jle": [
        "Latn"
    ],
    "jls": [
        "Zxxx"
    ],
    "jma": [
        "Latn"
    ],
    "jmb": [
        "Latn"
    ],
    "jmc": [
        "Latn"
    ],
    "jmd": [
        "Latn"
    ],
    "jmi": [
        "Latn"
    ],
    "jml": [
        "Deva"
    ],
    "jmn": [
        "Latn"
    ],
    "jmr": [
        "Latn"
    ],
    "jms": [
        "Latn"
    ],
    "jmw": [
        "Latn"
    ],
    "jmx": [
        "Latn"
    ],
    "jna": [
        "Zyyy"
    ],
    "jnd": [
        "Arab"
    ],
    "jng": [
        "Latn"
    ],
    "jni": [
        "Latn"
    ],
    "jnj": [
        "Latn",
        "Ethi"
    ],
    "jnl": [
        "Deva"
    ],
    "jns": [
        "Deva",
        "Latn",
        "Takr"
    ],
    "job": [
        "Latn"
    ],
    "jod": [
        "Latn"
    ],
    "jog": [
        "Arab"
    ],
    "jor": [
        "Latn"
    ],
    "jos": [
        "Zxxx"
    ],
    "jow": [
        "Latn"
    ],
    "jpa": [
        "Hebr"
    ],
    "jpr": [
        "Hebr"
    ],
    "jqr": [
        "Latn"
    ],
    "jra": [
        "Latn",
        "Khmr"
    ],
    "jrb": [
        "Hebr"
    ],
    "jrr": [
        "Latn"
    ],
    "jrt": [
        "Latn"
    ],
    "jru": [
        "Latn"
    ],
    "jsl": [
        "Zxxx"
    ],
    "jua": [
        "Latn"
    ],
    "jub": [
        "Latn"
    ],
    "juc": [
        "Jurc"
    ],
    "jud": [
        "Latn"
    ],
    "juh": [
        "Latn"
    ],
    "jui": [
        "Latn"
    ],
    "juk": [
        "Latn"
    ],
    "jul": [
        "Deva"
    ],
    "jum": [
        "Latn"
    ],
    "jun": [
        "Orya"
    ],
    "juo": [
        "Latn"
    ],
    "jup": [
        "Latn"
    ],
    "jur": [
        "Latn"
    ],
    "jus": [
        "Zxxx"
    ],
    "jut": [
        "Latn"
    ],
    "juu": [
        "Latn"
    ],
    "juw": [
        "Latn"
    ],
    "juy": [
        "Orya"
    ],
    "jv": [
        "Latn",
        "Java"
    ],
    "jvd": [
        "Latn"
    ],
    "jvn": [
        "Latn"
    ],
    "jwi": [
        "Latn"
    ],
    "jya": [
        "Tibt"
    ],
    "jye": [
        "Hebr"
    ],
    "jyy": [
        "Latn"
    ]
};
